import DualCta from './dual-cta.component'

export default DualCta
